module.exports = __webpack_public_path__ + "static/media/choithramsHelpB.a090b45a.png";